import { isDefined } from '@sgme/fp';
import { OrderType } from 'apiConnector/blotters/secondaryOrderBlotter';
import { connect } from 'react-redux';
import { SecondaryOrderCancellationWorkflow } from 'routes/secondaryMarketOrderBlotter/SidePanel/SecondaryOrderCancellationWorkflow';
import { getBlotterPanelItem } from 'state/blotters/blotterPanel/blotterPanel.selector';
import { DlpProductTradeItem } from 'state/blotters/trades/types/blotterItem';
import { CancellationStatus } from 'state/secondaryMarket/shared/cancellation/cancellation.model';
import { ThunkDispatch } from 'state/state.common';
import { AppState } from 'state/state.model';
import {
  tradeCancellationRequested,
  tradeCancellationWorkflowAborted,
} from 'state/trades/cancellations/cancellations.actions';
import {
  getTradeCancellationErrors,
  getTradeCancellationStatus,
} from 'state/trades/cancellations/cancellations.selectors';

type StateProps = {
  orderId: string;
  isin?: string;
  orderType?: OrderType;
  status: CancellationStatus | undefined;
  error: string | undefined;
};
type DispatchProps = {
  onCancellationWorkflowConfirmed: (orderId: string, isin?: string) => void;
  onCancellationWorkflowAborted: (orderId: string) => void;
  onCancellationWorkflowCompleted: (orderId: string) => void;
};
const mapStateToProps = (state: AppState): StateProps => {
  const trade = getBlotterPanelItem(state) as DlpProductTradeItem;
  const status = getTradeCancellationStatus(state, trade.tradeReference);
  const errors = getTradeCancellationErrors(state, trade.tradeReference)
    ?.map(e => e.rejectionMessage)
    .filter(isDefined)
    .join('\n');
  return {
    error: errors,
    orderId: trade.tradeReference as string,
    status,
    orderType: undefined,
    isin: trade.productIsin,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
  return {
    onCancellationWorkflowAborted(orderId) {
      dispatch(tradeCancellationWorkflowAborted(orderId));
    },
    onCancellationWorkflowCompleted(orderId) {
      dispatch(tradeCancellationWorkflowAborted(orderId));
    },
    onCancellationWorkflowConfirmed(orderId, isin) {
      dispatch(tradeCancellationRequested(orderId, isin));
    },
  };
};

export const TradeCancellationBanner = connect(mapStateToProps, mapDispatchToProps)(SecondaryOrderCancellationWorkflow);
